export enum NOTICE_CARD_TYPE {
  operate, // 展示用户接受/拒绝操作
  private_im,
  team_announce = 5,
  channel_im = 6,
  team_center = 7,
  team_push = 8,
  first_notice = 9,
  notice_change = 10,
  chat_group_im = 11,
  global_team_im = 12,
  activity_box = 99
}